import axios from "axios";

const instance = axios.create({
    baseURL: `https://rest.campograndems.labinovaapsfiocruz.com.br/`,
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
});

// instance.defaults.headers.common['SOMETHING'] = 'SOMETHING'

export default instance;
